export const WELCOME = 'Welcome';
export const ENGAGEMENT = 'Engagement';
export const MOTIVATOR = 'Motivator';
export const PRE_ENGAGEMENT = 'PreEngagement';
export const GO_TO_MY_REPORT = 'GoToMyReport';
export const PRELIMINARY_QUESTIONS = 'PreliminaryQuestions';
export const EXPIRED_ENGAGEMENT = 'ExpiredEngagement';
export const THANK_YOU = 'ThankYou';
export const CLOSED_ENGAGEMENT = 'ClosedEngagement';
